import angular from 'angular';

import DateGrouping from './date';

class CreationDateGrouping extends DateGrouping {
  constructor($filter) {
    super();

    this.dateFilter = $filter('date');
    this.key = 'creationDate';
    this.displayName = 'Creation Date';

    // #74524284: creation data selectors should be ordered by most recent first.
    this.groupingReverseSorted = true;

    this.columnsByGroup = this.setColumns([
      'contributors',
      'title',
      'content',
      'sources',
      'legalIssues',
      'factDateish',
      'tags'
    ]);
  }

  getDisplayText(rawDate) {
    return this.dateFilter(rawDate, 'MMM d, y');
  };

  getItemsByFact(fact) {
    var items = [];
    items.push(this.dateFilter(fact[this.key], 'yyyyMMdd'));
    return items;
  };

  getDocDisplayText(value) {
    return this.getDisplayText(value)
  };
  getSortingValue(value) {
    return this.getDisplayText(value)
  };
  getMemoText(value) {
    return this.getDisplayText(value)
  };
  getHeaderDisplayName(value) {
    return super.getDisplayName(value)
  };
}
CreationDateGrouping.$inject = ['$filter'];

export default angular.module('groupings.creation-date-grouping', [])
  .service('CreationDateGrouping', CreationDateGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/creation-date.js